import * as React from "react";

const Map = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#D2D5D8"
        d="M32 47S19 31.758 19 24.726C19 17.693 24.822 12 32 12s13 5.697 13 12.726C45 31.754 32 47 32 47z"
      />
      <path
        stroke="#7B838C"
        strokeWidth={3.2}
        d="M32 44.486a116.866 116.866 0 0 0 5.185-6.899 76.032 76.032 0 0 0 2.775-4.282c2.211-3.702 3.44-6.708 3.44-8.58C43.4 18.59 38.303 13.6 32 13.6c-6.304 0-11.4 4.987-11.4 11.126 0 1.871 1.228 4.876 3.438 8.577a75.965 75.965 0 0 0 2.777 4.285A116.776 116.776 0 0 0 32 44.486z"
      />
      <g>
        <path
          fill="#FFF"
          d="M32 31.09c-3.59 0-6.5-2.847-6.5-6.364 0-3.514 2.91-6.362 6.5-6.362 3.591 0 6.5 2.848 6.5 6.362 0 3.517-2.909 6.365-6.5 6.365z"
        />
        <path
          stroke="#7B838C"
          strokeWidth={3.2}
          d="M32 29.49c2.715 0 4.9-2.139 4.9-4.764 0-2.623-2.185-4.762-4.9-4.762-2.713 0-4.9 2.14-4.9 4.762 0 2.625 2.186 4.765 4.9 4.765z"
        />
      </g>
    </g>
  </svg>
);

export default Map;

